import { lazy } from 'react';
import withLazy from '~/components/LazySuspense';

export const LazySindicoAbout = withLazy(lazy(() => import('~/pages/Sindico/About')));
export const LazySindicoFiles = withLazy(lazy(() => import('~/pages/Sindico/Files')));
export const LazySindicoGestores = withLazy(lazy(() => import('~/pages/Sindico/Gestores')));
export const LazySindicoHome = withLazy(lazy(() => import('~/pages/Sindico/Home')));
export const LazySindicoMe = withLazy(lazy(() => import('~/pages/Sindico/Me')));
